// api/services/users.ts
import { handleRequest } from '@/api';
import type { AppUser, CreateUserRequest, UpdateUserRequest } from '@/types';

interface FetchOpts {
    signal?: AbortSignal;
}

interface UserOperationResponse {
    message: string;
    user_id: number;
    email_sent: boolean;
}

export const getUsers = (opts: FetchOpts = {}): Promise<AppUser[]> => handleRequest<AppUser[]>('get', `/users/`, opts);

export const saveNewUser = (payload: CreateUserRequest): Promise<UserOperationResponse> =>
    handleRequest<UserOperationResponse>('post', `/users/`, payload, 'User saved successfully!');

export const updateUser = (payload: UpdateUserRequest): Promise<UserOperationResponse> =>
    handleRequest<UserOperationResponse>('put', `/users/${payload.id}`, payload, 'User updated successfully');

export const deleteUser = (userId: number): Promise<void> =>
    handleRequest<void>('delete', `/users/${userId}`, {}, 'User deleted successfully!');
